import React from 'react';
import { connect } from 'react-redux';
import { startSetProfile, startSetResponse, startSetResponseForecast } from '../actions/globalState';
import { Link, Redirect, NavLink } from "react-router-dom";
import {history} from '../routers/AppRouter';
import defaultState from '../data/state';

import {Select, Tooltip, Icon} from 'antd';
const Option = Select.Option;

export class Profile extends React.Component {
  onProfileChange = (text) => {
    if(text === "Municipal Profile" || text === "Economic Profile") {
      this.props.startSetResponse(defaultState.geo_type, defaultState.geo_name, text)
    }  else if (text === "Population Forecasts") {
      this.props.startSetResponseForecast(text);
    } else {
      this.props.startSetProfile(text);
    }
  };
  render() {
    return (
      <div>
      <Select size="small" 
      className="profile"
      value={this.props.profile}
      onChange={value => this.onProfileChange(value)}
      >
        <Option value="Municipal Profile"> <Link to="/" className="profile-link" aria-label="Municipal Profile">Municipal Profile</Link></Option>
        <Option value="Population Forecasts"> <Link to="/populationforecast" className="profile-link" aria-label="Population Forecasts">Population Forecasts</Link></Option>
        <Option value="Economic Profile"><Link className="profile-link" to="/economicprofile" aria-label="Economic Profile">Economic Profile</Link></Option>
        <Option value="Economic Model"><Link className="profile-link" to="/economicmodel" aria-label="Economic Model">Economic Model</Link></Option>
      </Select>
      <Tooltip title="Use this drop down menu to select the section of the site you want to visit">
      <Icon type="question-circle" className="white" />
    </Tooltip>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  profile: state.globalState.profile
});

const mapDispatchToProps = (dispatch) => ({
  startSetProfile: (text) => dispatch(startSetProfile(text)),
  startSetResponseForecast: (text) => dispatch(startSetResponseForecast(text)),
  startSetResponse: (geo_type, geo_name, text) => dispatch(startSetResponse(geo_type, geo_name, text)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Profile);




// WEBPACK FOOTER //
// ./src/components/Profile.js